// extracted by mini-css-extract-plugin
export default {"nav":"blocks_tabs_nav","nav-item":"blocks_tabs_nav-item","active":"blocks_tabs_active","dark":"blocks_tabs_dark","tab":"blocks_tabs_tab"};